import { createContext, useContext } from "react";

export const RiderPortalContext = createContext(null);

export function useRiderPortal() {
  const context = useContext(RiderPortalContext);
  if (!context) throw new Error("useRiderPortal must be used inside RiderPortalGuard");
  return context;
}

